<template>
    <div id="morozenoe">
        <div class="bg"></div>
        <div class="start">
            <h1><span>Мороженое: <b>&laquo;тот самый вкус&raquo;</b></span></h1>
            <p>Его рекомендуют известные люди нашей страны, любят от&nbsp;мала до&nbsp;велика: дети&nbsp;&mdash; потому что вкусно, взрослые&nbsp;&mdash; потому что &laquo;тот самый вкус.&raquo;</p>
        </div>
        <div class="text">
            <h3>Настоящее мороженое</h3>
            <p>Настоящее мороженое &laquo;Коровка из&nbsp;Кореновки&raquo; готовится из&nbsp;свежайших кубанских сливок и&nbsp;сгущенного молока собственного 
            производства, уникальная рецептура которого держится в&nbsp;строжайшем секрете. Фантастический вкус пломбира &laquo;Коровка 
            из&nbsp;Кореновки&raquo;&nbsp;&mdash; настоящее достояние страны: бренд лидирует на&nbsp;рынке мороженого в&nbsp;России. 
            В&nbsp;ассортименте представлены несколько видов мороженого, в&nbsp;том числе &laquo;0%&nbsp;сахара&raquo; и&nbsp;оригинальные фруктово-ягодные шербеты.</p>
            
            <div class="image">
                <div class="korenovsk"></div>
                <div class="absolute">Дети Краснодара<br>на&nbsp;празднике города с&nbsp;любимым мороженым &laquo;Коровка из Кореновки&raquo;</div>
            </div>
            
            <p>В&nbsp;конце сентября в&nbsp;Краснодаре проходит празднование годовщины основания города. &laquo;Коровка из&nbsp;Кореновки&raquo;&nbsp;&mdash;&nbsp;бренд мороженого номер один в России&nbsp;&mdash;&nbsp;родом из&nbsp;солнечной и&nbsp;щедрой Кубани. Особая душевность бренда и&nbsp;продукция самого высокого качества стали настоящей гордостью Краснодарского края. <p> 
            
            <div class="block">
                <h4>Лидер на&nbsp;рынке мороженого в&nbsp;России</h4>
                <blockquote>Безоговорочное правило при производстве мороженого &laquo;Коровка из&nbsp;Кореновки&raquo;&nbsp;&mdash; соответствие нормам ГОСТа, по&nbsp;мнению признанных экспертов, во&nbsp;многом превосходящих эталонные стандарты ГОСТа советского периода.</blockquote>           
            </div>
        </div>
        
        <div class="list">
            <h2>Награды</h2>
            <div class="item item-img1">
                <div class="item-content">
                    <h3>Мороженое пломбир</h3>
                    <p>Диплом &laquo;За&nbsp;высокое качество производимой продукции&raquo; конкурса &laquo;Сто лучших товаров России&nbsp;&mdash; 2012&raquo;</p>
                    <p>Диплом &laquo;За&nbsp;лучшую молочную продукцию&raquo; на&nbsp;Всероссийском конкурсе-смотре &laquo;Молочные продукты&nbsp;&mdash; 2012&raquo;</p>
                    <p>Золотая медаль на&nbsp;Международной выставке &laquo;Зеленая неделя&nbsp;&mdash; 2013&raquo; в&nbsp;Берлине</p>
                    <p>Золотая медаль &laquo;За&nbsp;качество&raquo; и диплом&nbsp;I&nbsp;степени на&nbsp;<nobr>23-й</nobr> Международной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2016&raquo;, конкурс &laquo;За&nbsp;высокие потребительские свойства&raquo;</p>
                    <p>Победитель программы &laquo;Контрольная закупка&raquo;, посвященной мороженому пломбир, 2016&nbsp;г.</p>
                    <p>Золотая медаль &laquo;За&nbsp;качество&raquo; и&nbsp;диплом&nbsp;I степени на&nbsp;<nobr>25-й</nobr> Международной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2018&raquo;, конкурс &laquo;За&nbsp;высокие потребительские свойства&raquo;</p>
                </div>
            </div>
            <div class="item item-img2">
                <div class="item-content">
                    <h3>Мороженое эскимо</h3>
                    <p>Диплом &laquo;За&nbsp;высокое качество производимой продукции&raquo; на&nbsp;конкурсе &laquo;Сто лучших товаров России&nbsp;&mdash; 2012&raquo;</p>
                    <p>Золотая медаль на&nbsp;Международной выставке &laquo;Зеленая неделя&nbsp;&mdash; 2013&raquo; в&nbsp;Берлине</p>
                </div>
            </div>
            
            <div class="item item-img3">
                <div class="item-content">
                    <h3>Десерт шербет <br>традиционный замороженный</h3>
                    <p>Золотая медаль &laquo;За&nbsp;качество&raquo; и&nbsp;диплом&nbsp;степени на&nbsp;<nobr>25</nobr> Международной выставки продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2018&raquo;, конкурс &laquo;За&nbsp;высокие потребительские свойства&raquo;</p>
                </div>
            </div>

            <div class="item item-img4">
                <div class="item-content">
                    <h3>Мороженое пломбир фисташковый <br>в&nbsp;вафельном стакане <br>&laquo;Коровка&nbsp;из&nbsp;Кореновки&raquo;</h3>
                    <p>Золотая медаль и&nbsp;диплом высшей степени &laquo;За&nbsp;высокие потребительские свойства&raquo; по&nbsp;итогам дегустационного конкурса в&nbsp;рамках 27&nbsp;международной выставки&nbsp;&laquo;Продэкспо-2020&raquo;.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IceCream"
    }
</script>